export default {"src":"/_next/static/media/english.77011c11.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};